import React, {Component} from "react";


class PersianNumberForDate extends Component {


   render() {
       let en_number = this.props.number.toString();
       let persianDigits = "۰۱۲۳۴۵۶۷۸۹";
       let persianMap = persianDigits.split("");
       let persian_number = en_number.replace(/\d/g, function (m) {
         return persianMap[parseInt(m)];
       });

    return (

        <div>{persian_number}</div>
    )


  }

}


export default PersianNumberForDate
